import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const InvoicePaymentsTable = ({
  payments,
  onRefund,
  isLoading,
  formatCurrency,
  formatDateTime,
  statusColor,
}) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Invoice Payments</Heading>
          <Text fontSize="sm" color="gray.500">
            {payments.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : payments.length === 0 ? (
          <EmptyState title="No payments yet" description="Payments will appear after invoices are paid." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Invoice</Th>
                  <Th>Customer</Th>
                  <Th>Transaction</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {payments.map((payment) => (
                  <Tr key={payment.id}>
                    <Td>{payment.invoice?.invoiceNumber || `#${payment.invoice?.id}`}</Td>
                    <Td>{payment.invoice?.customerEmail || payment.payerEmail}</Td>
                    <Td>{payment.transactionId || "-"}</Td>
                    <Td isNumeric>{formatCurrency(payment.amount, payment.currency)}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(payment.status)}>{payment.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(payment.createdAt)}</Td>
                    <Td>
                      <Button
                        size="xs"
                        variant="outline"
                        colorScheme="orange"
                        isDisabled={payment.status !== "SUCCESS"}
                        onClick={() => onRefund(payment)}
                      >
                        Refund
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default InvoicePaymentsTable;
